// extracted by mini-css-extract-plugin
export default {"swiper":"Testimonial_swiper__ltY2a","swiper-slide":"Testimonial_swiper-slide__Bgywm","img":"Testimonial_img__WyhWm"};